import { RouteType } from "../../../types/RouteType";

const DrawingManagementRoute: RouteType = {
  name: "Drawing Management",
  path: "/drawing-management",
  layout: "/app",
  viewportCard: {
    header: {
      component: () => import("./DrawingManagementHeader"),
      title: "Drawing Management",
      color: "primary",
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      component: () => import("./DrawingManagementBody"),
      grayBackground: true,
    },
  },
  requiresPermission: false,
  dialogs: [
    {
      name: "DrawingUpload",
      component: () => import("./DrawingUploadDialog"),
      title: "Upload Drawing",
      // onSubmit: async ({ rootStore }) => {
      //   const { routerStore } = rootStore;

      //   routerStore.closeDialog();
      // },
      // onSubmitValidation: () => {
      //   return true;
      // },
      cancelButton: true,
      height: 500,
    },
    {
      name: "DrawingViewer",
      component: () => import("./DrawingViewer"),
      title: "View Drawing",
      cancelButton: false,
      height: 800,
    },
  ],
  beforeEnter: async ({ queryParams, rootStore }) => {
    const panelStore = (rootStore as any).panelStore;

    await panelStore.find({ query: { $limit: 1000 } });

    const drawingManagementStore = (rootStore as any).drawingManagementStore;

    if (queryParams.markNumber) {
      await drawingManagementStore.setSelectedMarkNumber(
        queryParams.markNumber
      );
      await drawingManagementStore.loadDrawings(queryParams.markNumber);
    } else {
      // Load all drawings when no mark number is specified
      await drawingManagementStore.loadDrawings();
    }

    return true;
  },
  onParamsChange: async ({ params, rootStore }) => {
    const drawingManagementStore = (rootStore as any).drawingManagementStore;

    if (params.markNumber) {
      await drawingManagementStore.setSelectedMarkNumber(params.markNumber);
      await drawingManagementStore.loadDrawings(params.markNumber);
    } else {
      // Clear selection and load all drawings when mark number is removed
      await drawingManagementStore.setSelectedMarkNumber(null);
      await drawingManagementStore.loadDrawings();
    }
  },
  requiresAuth: true,
  requiresAdmin: false,
};

export default DrawingManagementRoute;
